import {getActionType, TYPES} from '../util/redux';
import {WorkType, PAGESIZE} from '../action/works';
//分tab分页数据存储
const initState = {
    request0 : true,
    request1 : false,
    request2 : false,
    request3 : false,
    delrequest : false,
    tryrequest : false,
    querylsrequest : false,
    msg0 : '',
    msg1 : '',
    msg2 : '',
    msg3 : '',
    data0 : {
        total : 0,
        page : 1
    },
    data1 : {
        total : 0,
        page : 1
    },
    data2 : {
        total : 0,
        page : 1
    },
    data3 : {
        total: 0,
        page: 1
    }
}
const type1 = getActionType(WorkType, 'request0');
const type2 = getActionType(WorkType, 'success');
const type3 = getActionType(WorkType, 'fail');
const type4 = getActionType(WorkType, 'clear');
const type5 = getActionType(WorkType, 'request1');
const type6 = getActionType(WorkType, 'request2');
const typerequest3 = getActionType(WorkType, 'request3');
const type7 = getActionType(WorkType, 'delrequest');
const type8 = getActionType(WorkType, 'delcomplete');
const type9 = getActionType(WorkType, 'savepage');
const type10 = getActionType(WorkType, 'tryrequest');
const type11 = getActionType(WorkType, 'trycomplete');
const type12 = getActionType(WorkType, 'clearsgtab');
const type13 = getActionType(WorkType, 'edititem');
const type14 = getActionType(WorkType, 'querylistrequest');
const type15 = getActionType(WorkType, 'queryliststatus');
const craftsuccess = getActionType(WorkType, 'craftsuccess');
const craftfail = getActionType(WorkType, 'craftfail');

//删除列表后的操作
const disposeAfterDel = function({data, page, list}){
    //可能存在当前页被删光
    if(list.length > 0){
        data[page] = list;    
    }
    else{
        //删光,如果在最后一页则往前翻一页，页数更改;
        //如果不是最后一页则往后翻一页，整体数组往前挪一位;
        let maxPage = Math.ceil(data.total/PAGESIZE);
        if(page == maxPage){
            delete data[page];
            data['page'] = page - 1;
        }
        else{
            let curNewData = {};
            for(let p in data){
                let n = parseInt(p, 10);
                if(!isNaN(n) && n > page){
                    curNewData[n - 1] = data[n];
                }
                else{
                    if(n != page){
                        curNewData[p] = data[p];
                    }
                }
            }
            data = curNewData;
        }
    }
    return data;
}
//0 已发布, 1 发布中, 2 已锁定
export default function worksReducer(state = initState, action){
    let {type, payload} = action;
    switch(type){
        case type1:
            //清空数据
            let qlrData = state.data0;
            if(payload._clear){
                qlrData = {};
            }
            return {
                ...state,
                request0 : true,
                msg0 : '',
                data0 : qlrData
            }
        case type5:
            return {
                ...state,
                request1 : true,
                msg1 : '',
                data1 : {
                    ...state.data1
                }
            }
        case type6:
            return {
                ...state,
                request2 : true,
                msg2 : '',
                data2 : {
                    ...state.data2
                }
            }
        case typerequest3:
            return {
                ...state,
                request3 : true,
                msg3 : '',
                data3 : {
                    ...state.data3
                }
            }
        case type2:
            delete payload.code;
            let status = payload._status;
            let page = payload._page;
            let list = payload.data;
            let showExposure = payload.showExposure;
            let total = payload.total;
            let odata = state['data' + status];
            odata[page] = list;
            odata.total = total;
            odata.showExposure = showExposure;
            //测试
            // if(status == 1){
            //     list[0].uploadStatus = -1;
            // }
            return {
                ...state,
                ['request' + status] : false,
                ['msg' + status] : '',
                ['data' + status] : odata
            }
        case type3:
            let cstatus = payload._status;
            let rcode = payload.code;
            let rmsg = payload.msg;
            return {
                ...state,
                ['request' + cstatus] : false,
                ['msg' + cstatus] : rmsg
            }
        case type7:
            return {
                ...state,
                delrequest : true,
            }
        case type8:  //删除视频
            let {success} = payload;
            //let newData = {};
            if(success){
                let npage = payload.page;
                let nstatus = payload.status;
                let nId = payload.videoId;
                let ndata = state['data' + nstatus];
                let nlist = ndata[npage];
                for(let i=0,len=nlist.length;i<len;i++){
                    if(nlist[i].videoId == nId){
                        nlist.splice(i, 1);
                        break;
                    }
                }
                ndata.total = ndata.total - 1;
                ndata = disposeAfterDel({
                    list : nlist,
                    data : ndata,
                    page : npage
                });
                return {
                    ...state,
                    delrequest : false,
                    ['data' + nstatus] : ndata
                }
            }
            return {
                ...state,
                delrequest : false
            }
        case type9:  //保存page,且清空msg
            let spage = payload.page;
            let sstatus = payload.status;
            let sdata = state['data' + sstatus];
            sdata['page'] = spage;
            return {
                ...state,
                ['msg' + sstatus] : '',
                ['data' + sstatus] : sdata
            }
        case type10: //请求重新发布
            return {
                ...state,
                tryrequest : true
            }
        case type11: //重新发布处理
            let trySucc = payload.success;
            if(trySucc){
                let typage = payload.page;
                let tystatus = payload.status;
                let tyId = payload.videoId;
                let tydata = state['data' + tystatus];
                let tylist = tydata[typage];
                //上传状态设置为发布中
                for(let i=0,len=tylist.length;i<len;i++){
                    if(tylist[i].videoId == tyId){
                        tylist[i].uploadStatus = 0;
                        break;
                    }
                }
                return {
                    ...state,
                    tryrequest : false,
                    ['data' + tystatus] : tydata
                }
            }
            return {
                ...state,
                tryrequest : false
            }
        case type12: //清除单个tab的数据
            let tbStatus = payload;
            return {
                ...state,
                ['data' + tbStatus] : {
                    total : 0,
                    page : 1
                }
            }
        case type13: //修改视频信息,需要完成歌曲信息,bgms列表不展示暂时不处理
            let edProps = ['tagList', 'description', 'title', 'coverIdStr', 'coverUrl'];
            let edVideoId = payload.videoId;
            let edStatus = 0;
            let edData = state['data' + edStatus];
            let edpage = edData['page'];
            let edList = edData[edpage];
            //找出对应视频并修改
            if(edList && edList.length){
                for(let i=0,len=edList.length;i<len;i++){
                    if(edList[i].videoId == edVideoId){
                        for(let k=0,len=edProps.length;k<len;k++){
                            edList[i][edProps[k]] = payload[edProps[k]]
                        }
                    }
                }
            }
            return {
                ...state,
                ['data' + edStatus] : edData
            }
        case type14: //
            return{
                ...state,
                querylsrequest : true
            }
        case type15: //tab=1中去除已经转码成功的视频
            let qlsSucc = payload.success;
            if(qlsSucc){
                let qlsData = payload.data;
                let taboPage = payload.page;
                let taboData = state['data1'];
                let taboList = taboData[taboPage];
                let delCount = 0;
                for(let i=0,len=taboList.length;i<len;i++){
                    if(qlsData[taboList[i].videoId] == 1){
                        taboList[i] = 'null';  //不改变数据先处理这样
                        delCount ++;
                    }
                    else if(qlsData[taboList[i].videoId] == -1){
                        taboList[i].uploadStatus = -1;
                    }
                }
                taboList = taboList.filter(function(item, n){
                    return item != 'null';
                });
                taboData.total -= delCount;
                taboData = disposeAfterDel({
                    data : taboData, 
                    page : taboPage, 
                    list : taboList
                });
                return {
                    ...state,
                    querylsrequest : false,
                    ['data1'] : taboData
                }
            }
            return {
                ...state,
                querylsrequest : false
            }
        case TYPES.CLEAR_ALL:case type4:
            return {
                ...initState
            }
        case craftsuccess: 
            delete payload.code;
            total = payload.total;
            odata = state['data' + 3];
             // 过滤草稿箱来不及删除的过期草稿们
            const date = new Date();
            const data = payload.data.filter((itm) => itm.expireTime > date);
            odata[payload._page] = data;
            odata.total = data.length;
            return {
                ...state,
                ['request' + 3] : false,
                ['msg' + 3] : '',
                ['data' + 3] : odata
            }
        case craftfail: 
            cstatus = 3;
            rcode = payload.code;
            rmsg = payload.msg;
            return {
                ...state,
                ['request' + cstatus] : false,
                ['msg' + cstatus] : rmsg
            }
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./client/reducers/works.js